import { useContext, useEffect, useRef, useState } from "react";
import { Col, Row, Image } from "react-bootstrap";
import { gsap } from "gsap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBook,
  faDownload,
  faListOl,
  faPen,
} from "@fortawesome/free-solid-svg-icons";
import styles from "./MaterialDownloader.module.scss";
import { pdfDownloadIcon } from "../../assets";
import { useIncrementFilesDown } from "../../hooks/useIncrementFilesDown";
import { DataContex } from "../../context/DataContext";
import { nombresCiclos } from "../../helpers/nombresCiclos";

export const MaterialDownloader = ({ data, numeroDeDescargas = true }) => {
  const { windowSize } = useContext(DataContex);
  const downloader = useRef(null);
  const { incrementFilesDown } = useIncrementFilesDown();
  // const handleCkickPDF = (file, id) => {
  //   console.log(file, id);
  //   window.open(file);
  //   incrementFilesDown(id);
  // };
  // const handleCkickPDF = (file, id = "sinId") => {
  //   console.log(id);
  //   window.open(file);
  //   incrementFilesDown(id);
  // };

  const handleCkickPDF = (file, id = "sinId") => {
    try {
      // console.log(id);
      window.open(file);
      incrementFilesDown(id);
    } catch (error) {
      console.error("Error en handleCkickPDF:", error);
    }
  };

  const [over, setOver] = useState(false);
  const [out, setOut] = useState(true);
  const mouseOver = () => {
    setOver(true);
    setOut(false);
  };
  const mouseOut = () => {
    setOver(false);
    setOut(true);
  };

  useEffect(() => {
    if (over) {
      gsap.to(downloader.current, { y: 300, duration: 0.2, ease: "ease.out" });
    }
  }, [over]);

  useEffect(() => {
    if (out) {
      gsap.to(downloader.current, { y: 0, duration: 0.2, ease: "ease.out" });
    }
  }, [out]);

  const [isXs, setIsXs] = useState(false);

  useEffect(() => {
    if (windowSize.windowsName === "appXs") {
      setIsXs(true);
    }
  }, [windowSize.windowsName]);

  console.log('data: ', data)

  return (
    <Col
      className={`${styles.framne}`}
      // onClick={() => handleCkickPDF(data.link, data.id)}
      onClick={() => handleCkickPDF(data.link, data.id ? data.id : "sinId")}
      role='button'>
      <Col
        ref={downloader}
        className={`${styles.dataText}`}
        onMouseOver={mouseOver}
        onMouseLeave={mouseOut}>
        <Row className={`h-100 sm-align-items-center md-align-items-center xs-align-items-start`} >
          {isXs ? (
            ""
          ) : (
            <Col xs={2} sm={2} md={1} className={`${styles.pdfIcon}`}>
              <Image src={pdfDownloadIcon} fluid/>
            </Col>
          )}

          <Col  sm={4} md={4} lg={3} >
            <Row className={`h-100 align-items-center`}>

              {data.tipo === "Actividad" ? (
                <Col md={12}>
                  <li className={`${styles.tipo}`}>
                    <strong>
                      <Row className={``}>
                        <Col className={``} xs={3}>
                          <FontAwesomeIcon icon={faPen} size='2xl' />
                        </Col>
                        <Col className={``} xs={9}>Actividad</Col>
                      </Row>
                    </strong>
                  </li>
                </Col>
              ) : (
                ""
              )}
              {data.tipo === "Investigación" ? (
                <Col md={12}>
                  <li className={`${styles.tipo}`}>
                    <strong>
                      <Row>
                        <Col xs={3}>
                          <FontAwesomeIcon icon={faBook} size='2xl' />
                        </Col>
                        <Col xs={8}>Investigación</Col>
                      </Row>
                    </strong>
                  </li>
                </Col>
              ) : (
                ""
              )}
              {data.tipo === "Crucigrama" ? (
                <Col md={12}>
                  <li className={`${styles.tipo}`}>
                    <strong>
                      <Row>
                        <Col xs={3}>
                          <FontAwesomeIcon icon={faListOl} size='2xl' />
                        </Col>
                        <Col xs={9}>Crucigrama</Col>
                      </Row>
                    </strong>
                  </li>
                </Col>
              ) : (
                ""
              )}
             

            </Row>

          </Col>
          <Col sm={6} md={7}>
            <Row className={`${styles.ciclosBox} h-100 align-items-center`}>
              <Col xs={12} className={`${styles.tituloCiclos}`}>
                <p>Material para los siguientes ciclos:</p>
              </Col>
              <ul>
                {data.niveles.map((nivel, index) => (
                  <li key={index} className={`${styles.ciclos}`}>{nombresCiclos(nivel)}</li>
                ))}
              </ul>
            </Row>
          </Col>

        </Row>

      </Col>
      <Col className={``} onMouseOver={mouseOver} onMouseLeave={mouseOut}>
        <Row className={`${styles.iconDownload}`}>
          {numeroDeDescargas && (
            <Col>
              <h5>{data.descargas} Descargas realizadas</h5>
            </Col>
          )}
          <FontAwesomeIcon icon={faDownload} />
          <Col className='mt-3'>
            <h5>Descargar el documento</h5>
          </Col>
        </Row>
      </Col>
    </Col>
  );
};
